const parseNumber = (value = ""): string =>
  value.replace(",", ".").replace(/[^0-9.]/g, "");

export default parseNumber;
